import React from 'react';
import {Link } from "react-router-dom";
import { ROUTES } from '../../routes';
import useCustomTranslation from '../../hooks/useCustomTranslation';

const Navigation = (props) => {

  const ct = useCustomTranslation();
  const projectId = props.projectId;

  const navElements = [
    { title: ct('account.navigation.to_projectunits'), linkTo: ROUTES.TO_PROJECT(projectId), key: "projectunits"},
    { title: ct('account.navigation.to_basic_project_data'), linkTo: ROUTES.TO_PROJECT_BASICS(projectId), key: "project_basic_data" },
    { title: ct('account.navigation.to_contact_person'), linkTo: ROUTES.TO_PROJECT_CONTACT(projectId), key: "project_contact_data" },
    { title: ct('account.navigation.to_customer'), linkTo: ROUTES.TO_PROJECT_CUSTOMER(projectId), key: "project_customer_data" },
    { title: ct('account.navigation.to_project_help'), linkTo: ROUTES.TO_PROJECT_HELP(projectId), key: "project_help" },
  ]

  const linkClass = (key) => {
    return (key === props.activeItem)? "nav-link active" : "nav-link"
  }

  return (
    <ul className="nav nav-tabs flex-xl-column" role="tablist">
      {
        navElements.map( (e, i) => <li key={e.key} className="nav-item"><Link className={linkClass(e.key)} to={e.linkTo}>{e.title}</Link></li> )
      }
    </ul>
  )
}

export default Navigation;



// WEBPACK FOOTER //
// ./src/components/Project/Navigation.js